export default "__VITE_ASSET__DJcWVSY5__"